import { render, staticRenderFns } from "./CreateWeb.vue?vue&type=template&id=323fbcce&"
import script from "./CreateWeb.vue?vue&type=script&lang=ts&"
export * from "./CreateWeb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports